import { NavLink } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { FRONT_DESK_ROLE_ID, HOUSEKEEPING_ROLE_ID } from '@/lib/roles';

export default function CasaSectionNav() {
  const { profile } = useAuth();
  const isAdmin = profile?.access_level === 'super_admin';
  const canManage = isAdmin || profile?.access_level === 'operations_manager' || profile?.permissions.includes('manage_operations');
  const isFrontDesk = profile?.role_id === FRONT_DESK_ROLE_ID;
  const isHousekeeping = profile?.role_id === HOUSEKEEPING_ROLE_ID;

  const items = [
    ...(canManage ? [{ path: '/casa', icon: 'ri-dashboard-line', label: 'オペレーション' }] : []),
    ...(canManage || isFrontDesk ? [{ path: '/reservations', icon: 'ri-calendar-check-line', label: '予約管理' }] : []),
    ...(canManage || isHousekeeping ? [{ path: '/cleaning', icon: 'ri-brush-line', label: '清掃管理' }] : []),
  ];

  return (
    <div className="mb-4 rounded-xl border border-[#DED9CC] bg-[#FFFEFA] p-2">
      <div className="flex flex-wrap items-center gap-2">
        <div className="flex items-center gap-2 px-3 py-2 text-sm font-bold text-[#234638]">
          <i className="ri-hotel-line" />
          <span>Casa Kokoro</span>
        </div>
        <div className="h-6 w-px bg-[#DED9CC]" />
        {items.map((item) => (
          <NavLink
            key={item.path}
            to={item.path}
            className={({ isActive }) => `flex items-center gap-2 rounded-lg px-3 py-2 text-sm font-semibold transition-colors ${isActive ? 'bg-[#234638] text-white' : 'text-[#66665F] hover:bg-[#F0EDE5] hover:text-[#252824]'}`}
          >
            <i className={item.icon} />
            {item.label}
          </NavLink>
        ))}
      </div>
    </div>
  );
}
